import { FC, useEffect } from "react";
import Quill from "../../../components/common/quill/Quill";
import Button from "../../../components/button/Button";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import {
  artistsByContest,
  detailByContest,
  favoriteByContest,
} from "../../../api/asyncThuncks/contestsCards";
import { useNavigate, useParams } from "react-router-dom";
import { selectMainState, setSEOSettings } from "../../../store/slices/main";

type IProps = {
  icon?: string;
  title?: string;
  description?: string;
  date?: string;
  isCtaButtonActive?: boolean;
  ctaButtonTitle?: string;
  ctaButtonUrl?: string;
};

const HomeActiveСontests: FC<IProps> = ({
  icon,
  title,
  description,
  ctaButtonTitle,
  ctaButtonUrl,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { contestsHomePagUrls, contestHomePage } =
    useAppSelector(selectMainState);
  const href = window.location.href.split("/");
  const path = href[href.length - 1];

  const navigateAndSetSEOSettings = async (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string,
    publicUrl?: string
  ) => {
    // if (publicUrl) await dispatch(contestCardByPublicUrl(publicUrl));
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  useEffect(() => {
    if (contestsHomePagUrls)
      // dispatch(contestCardByPublicUrl(`${contestsHomePage}`));
      dispatch(detailByContest(`${contestsHomePagUrls}`));
    dispatch(favoriteByContest(`${contestsHomePagUrls}`));
    dispatch(artistsByContest(`${contestsHomePagUrls}`));
  }, [contestsHomePagUrls]);

  return (
    <>
      <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start md:h-[18.75rem]">
        <div className="min-w-[21.25rem] h-auto flex justify-start items-center overflow-hidden rounded-lg md:min-w-[30rem] md:h-[100%]">
          <img
            onClick={() => {
              if (contestHomePage.details)
                navigateAndSetSEOSettings(
                  `${
                    !!path.length
                      ? `${contestsHomePagUrls}`
                      : `contests/${contestsHomePagUrls}`
                  }`,
                  contestHomePage.details.title,
                  contestHomePage.details.description,
                  contestHomePage.details.imgPath,
                  `${contestsHomePagUrls}`
                );
            }}
            className="w-full h-full object-cover cursor-pointer"
            src={contestHomePage.details?.imgPath || icon}
            alt=""
          />
        </div>
        <div
          className={`h-full flex flex-col items-start justify-between md:pl-7 ${
            contestHomePage.details?.ctaButtonUrl || ctaButtonUrl
              ? ""
              : "md:justify-center"
          }`}
        >
          <div>
            <h3
              onClick={() => {
                if (contestHomePage.details)
                  navigateAndSetSEOSettings(
                    `${
                      !!path.length
                        ? `${contestsHomePagUrls}`
                        : `contests/${contestsHomePagUrls}`
                    }`,
                    contestHomePage.details.title,
                    contestHomePage.details.description,
                    contestHomePage.details.imgPath,
                    `${contestsHomePagUrls}`
                  );
              }}
              className="pt-5 text-2xl text-black font-bold text-ellipsis overflow-hidden line-clamp-2 md:hover:underline cursor-pointer md:pt-0 md:pb-[1rem]"
            >
              {contestHomePage.details?.title || title}
            </h3>
            <p
              className={`py-5 text-base md:py-0 ${
                contestHomePage.details?.ctaButtonUrl || ctaButtonUrl
                  ? "md:pt-0"
                  : "md:pt-0"
              }`}
            >
              <Quill
                text={contestHomePage.details?.description || description}
                className={`${!!path ? path : "home"} `}
              />
            </p>
          </div>
          {(contestHomePage.details?.ctaButtonUrl || ctaButtonUrl) && (
            <Button
              onClick={() => {
                window.open(
                  contestHomePage.details?.ctaButtonUrl || ctaButtonUrl,
                  "_blank"
                );
              }}
              title={contestHomePage.details?.ctaButtonTitle || ctaButtonTitle}
              className="text-[#202124] text-white bg-orange transition-opacity hover:opacity-90 hover:transition-opacity"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default HomeActiveСontests;
